import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Component used to group together items in a card.
 *
 * **Base CSS Class:** `ph-card`
 */

export default function CoreCard({ hideBorder, children, className, dark }) {
	return (
		<div
			className={
				classnames(
					'ph-card',
					className,
					{
						'no-border': !!hideBorder,
						dark
					}
				)
			}
		>
			{children}
		</div>
	);
}

CoreCard.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	hideBorder: PropTypes.bool,
	dark: PropTypes.bool
};
